// extracted by mini-css-extract-plugin
export default {"editRecordContainer":"EditRecord_editRecordContainer__0f8LP","editingHeader":"EditRecord_editingHeader__YuxkV"};